module.exports = __webpack_public_path__ + "static/media/Quote 1 - Mobile.65537ae9.png";